import { WarningOutlined } from '@ant-design/icons'

import useTranslations from '../hooks/useTranslations'

const PageNotFound = ({ message }) => {
  const { t } = useTranslations()
  return (
    <div className="not-found">
      <div className="not-found-img">
        <WarningOutlined />
      </div>
      {/* <h4 fontSize="20px">{message}</h4> */}
      <h4 fontSize="20px">{t('txt_PageNotFound')}</h4>
    </div>
  )
}

export default PageNotFound
